import {
  addPainAssessmentEndpoint,
  deletePainAssessmentEndpoint,
  updatePainAssessmentEndpoint,
} from "./api/PainAssessment";

export const addPainAssessment = async painAssessmentData => {
  try {
    const newPainAssessment = painAssessmentData;
    const response = await addPainAssessmentEndpoint(newPainAssessment);
    return response;
  } catch (error) {
    throw new Error(`Error adding new Pain Assessment: ${error.message}`);
  }
};

export const updatePainAssessment = async (painAssessmentId, painAssessmentData) => {
  try {
    const response = await updatePainAssessmentEndpoint(painAssessmentId, painAssessmentData);
    return response;
  } catch (error) {
    throw new Error(`Error updating Pain Assessment: ${error.message}`);
  }
};

export const deletePainAssessment = async painAssessmentId => {
  try {
    const response = await deletePainAssessmentEndpoint(painAssessmentId);
    return response;
  } catch (error) {
    throw new Error(`Error deleting Pain Assessment: ${error.message}`);
  }
};
